import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { Container, Draggable } from 'react-smooth-dnd'
import { dispatch } from '@rematch/core';
import uniqid from 'uniqid';
import diamond from '../../../../../../../images/grafix-icon/diamond.svg'
import Loader from './Loader'
import Card from './Card'
import NewCard from './NewCard'
import { AddCardLink, LaneFooter, LaneHeader, ScrollableLane, Section, Title } from '../../../../../lifecycleDesigner/drive/Activity/styles/Base'
import ActivityCard from '../../../cards/ActivityCardNew';
import * as laneActions from '../actions/LaneActions'
import { CollapseBtn, ExpandBtn } from '../../styles_delete/Elements'
import { Icon, Popup, Image } from "semantic-ui-react";
import EllipsisTooltip from '../../../../../../common/EllipsisTooltip';
import ImageAvater from '../../../../../../drive/Components/ImageAvater'

class Lane extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      currentPage: this.props.currentPage,
      addCardMode: false,
      collapsed: false,
      isDraggingOver: false
    }
  }

  handleScroll = evt => {
    const node = evt.target
    const elemScrolPosition = node.scrollHeight - node.scrollTop - node.clientHeight
    const { onLaneScroll } = this.props
    if (elemScrolPosition <= 0 && onLaneScroll && !this.state.loading) {
      const { currentPage } = this.state
      this.setState({ loading: true })
      const nextPage = currentPage + 1
      onLaneScroll(nextPage, this.props.id).then(moreCards => {
        if (!moreCards || moreCards.length === 0) {
          // if no cards present, stop retrying until user action
          node.scrollTop = node.scrollTop - 100
        } else {
          this.props.actions.paginateLane({
            laneId: this.props.id,
            newCards: moreCards,
            nextPage: nextPage
          })
        }
        this.setState({ loading: false })
      })
    }
  }

  sortCards(cards, sortFunction) {
    if (!cards) return []
    if (!sortFunction) return cards
    return cards.concat().sort(function (card1, card2) {
      return sortFunction(card1, card2)
    })
  }

  laneDidMount = node => {
    if (node) {
      node.addEventListener('scroll', this.handleScroll)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.cards, nextProps.cards)) {
      this.setState({
        currentPage: nextProps.currentPage
      })
    }
  }

  removeCard = (laneId, cardId) => {
    this.props.actions.removeCard({ laneId: laneId, cardId: cardId })
  }

  handleCardClick = (e, card, laneId, idx) => {
    const { onCardClick } = this.props
    onCardClick && onCardClick(card.id, card.metadata, card.laneId);
    dispatch.initiatives.setIdToCenterPosition(card._id)
  }

  showEditableCard = () => {
    this.setState({ addCardMode: true })
  }

  hideEditableCard = () => {
    this.setState({ addCardMode: false })
  }

  addNewCard = params => {
    const laneId = this.props.id
    const id = uniqid()
    this.hideEditableCard()
    let card = { ...params, id }
    this.props.actions.addCard({ laneId, card })
    this.props.onCardAdd(card, laneId)
  }

  renderAddCardLink = () => {
    const { addCardLink } = this.props
    if (addCardLink) {
      return <span onClick={this.showEditableCard}>{addCardLink}</span>
    } else {
      return <AddCardLink onClick={this.showEditableCard}>Add Card</AddCardLink>
    }
  }

  renderNewCard = () => {
    const { newCardTemplate, id } = this.props
    if (newCardTemplate) {
      const newCardWithProps = React.cloneElement(newCardTemplate, {
        onCancel: this.hideEditableCard,
        onAdd: this.addNewCard,
        laneId: id
      })
      return <span>{newCardWithProps}</span>
    } else {
      return <NewCard onCancel={this.hideEditableCard} onAdd={this.addNewCard} />
    }
  }

  onDragStart = ({ payload }) => {
    const { handleDragStart } = this.props
    handleDragStart && handleDragStart(payload.id, payload.laneId)
  }

  shouldAcceptDrop = sourceContainerOptions => {
    return this.props.droppable && sourceContainerOptions.groupName === 'TrelloLane'
  }

  onDragEnd = (laneId, result) => {
    const { handleDragEnd } = this.props
    const { addedIndex, payload } = result
    if (addedIndex != null) {
      this.props.actions.moveCardAcrossLanes({
        fromLaneId: payload.laneId,
        toLaneId: laneId,
        cardId: payload.id,
        index: addedIndex
      })
      handleDragEnd && handleDragEnd(payload.id, payload.laneId, laneId, addedIndex, payload)
    }
  }

  renderDragContainer = isDraggingOver => {
    const {
      laneSortFunction,
      editable,
      hideCardDeleteIcon,
      tagStyle,
      cardStyle,
      draggable,
      cardDraggable,
      cards,
      cardDragClass,
      id,
      index,
      boardIndex,
      objectId
    } = this.props
    const { addCardMode, collapsed } = this.state;

    const laneId = `${boardIndex}_${index}`;
    const showableCards = collapsed ? [] : cards
    const cardList = this.sortCards(showableCards, laneSortFunction).map((card, idx) => {
      const cardToRender = (
        <Card
          id={card._id}
          key={idx}
          index={idx}
          customCardLayout={this.props.customCardLayout}
          customCard={this.props.children}
          tagStyle={tagStyle}
          cardStyle={cardStyle}
          removeCard={this.removeCard}
          onClick={e => this.handleCardClick(e, card, laneId, idx)}
          onDelete={this.props.onCardDelete}
          editable={editable}
          hideCardDeleteIcon={hideCardDeleteIcon}
          activeTab={this.props.activeTab ? this.props.activeTab : ""}
          selectedActivityData={this.props.selectedActivityData}
          activityRACIUsers={this.props.activityRACIUsers}
          selectedDataById={this.props.selectedDataById}
          card={card}
          selectedOrganisation={this.props.selectedOrganisation}
          user={this.props.user}
          setUniqueId={this.props.setUniqueId}
          {...card}
          currentOrganization={this.props.currentOrganization}

        />
      )
      return draggable && cardDraggable ? (
        <Draggable key={idx}>{cardToRender}</Draggable>
      ) : (
          <span key={idx}>{cardToRender}</span>
        )
    })
    let setHeight;
    let height = this.props.componentDesignerDimension;
    let cutHeight = height.windowHeight - height.height;
    // let setHeight = (height.windowHeight - height.height) - (this.props.title === 'Others' ? 260 : 430)

    if (this.props.title === 'Others') {
      setHeight = cutHeight - 330
    } else {
      setHeight = cutHeight - 430
    }


    return (
      <ScrollableLane innerRef={this.laneDidMount} isDraggingOver={isDraggingOver}>
        <div id={laneId}>
          <Container
            {...this.props}
            orientation="vertical"
            groupName="TrelloLane"
            dragClass={cardDragClass}
            onDragStart={this.onDragStart}
            onDrop={e => this.onDragEnd(id, e)}
            onDragEnter={() => this.setState({ isDraggingOver: true })}
            onDragLeave={() => this.setState({ isDraggingOver: false })}
            shouldAcceptDrop={this.shouldAcceptDrop}
            style={{ maxHeight: setHeight }}
            getChildPayload={index => this.props.getCardDetails(id, index)}>
            {cardList}
          </Container>
        </div>
        {editable && !addCardMode && this.renderAddCardLink()}
        {addCardMode && this.renderNewCard()}
      </ScrollableLane>
    )
  }

  assignModal = () => {

    let associatedTeamName = '', associatedCommunity, managers = [], members = [];

    this.props.associatedTeams && this.props.associatedTeams.forEach(community => {
      if (community._id === this.props.id) {
        if (community.associatedTeam._id === this.props.associatedTeam) {
          community.associatedTeam.members.forEach(member => {
            if (member.role === 'Manager') {
              managers.push({ ...member.accountUserId, accountUserId: member.accountUserId._id });
            }
            else if (member.role === "Member") {
              members.push({ ...member.accountUserId, accountUserId: member.accountUserId._id });
            }
          })
          if (!this.state.associatedCommunity)
            this.setState({ associatedCommunity: community, members: members, managers: managers });
          associatedTeamName = community.associatedTeam.name;
        }
      }

    })

    this.openAssigneeModal(associatedCommunity, managers, members);
  }

  openAssigneeModal = (associatedCommunity, managers, members) => {

    this.state.associatedCommunity.accountable = this.props.accountable;
    this.props.setAssignee(this.props.accountable)
    this.props.setManagers(this.state.managers);
    this.props.setMembers(this.state.members);
    this.props.setAssociatedCommunity(this.state.associatedCommunity);
    this.props.setChangeAccountableConfirmationModalOpen();
  }
  renderHeader = () => {

    const { customLaneHeader } = this.props
    if (customLaneHeader) {
      const customLaneElement = React.cloneElement(customLaneHeader, { ...this.props })
      return <span>{customLaneElement}</span>
    } else {
      const { title, label, issuelabel, completedlabel, titleStyle, labelStyle, associatedTeam, associatedTeams, isMilestone, accountable } = this.props
      let associatedTeamName = '';
      let associatedCommunity;
      let managers = [];
      let members = [];
      associatedTeams && associatedTeams.forEach(community => {
        if (community._id === this.props.id) {
          if (community.associatedTeam && community.associatedTeam._id === associatedTeam) {
            community.associatedTeam.members.forEach(member => {
              if (member.role === 'Manager') {
                managers.push({ ...member.accountUserId, accountUserId: member.accountUserId._id });
              }
              else if (member.role === "Member") {
                members.push({ ...member.accountUserId, accountUserId: member.accountUserId._id });
              }
            })
            if (!this.state.associatedCommunity)
              this.setState({ associatedCommunity: community, members: members, managers: managers });
            associatedTeamName = community.associatedTeam.name;
          }
        }

      })
      return (
        <div title="" >
          {/* <LaneHeader title="" {...this.props} className={`${isMilestone ? "milestone-color" : ""}`}>
            <Title title="" className={this.props.activeTab === "Teams" ? 'break-one-line white-space-normal' : 'break-two-line white-space-nowrap'} style={titleStyle}>

              {title}
              <div style={{ float: 'right' }}>
                {isMilestone ? <img src={diamond} name="diamond" style={{ 'height': '12px' }} alt='' /> : ""}
              </div>
              <br />
              {this.props.activeTab === "Teams" ? <span style={{ display: 'block' }}><Icon name="group" />{associatedTeamName}</span> : ''}

              {this.props.activeTab === "Teams" && accountable ? <div className='text-muted' style={{ display: 'flex', position: 'relative' }}>
                <ImageAvater user={accountable} className="mini" imageStyle="w_16 h_16" />

                <EllipsisTooltip style={{ width: "calc(100% - 80px)", display: "block", textOverflow: "ellipsis" }}
                  name={accountable.firstName + " " + accountable.lastName} />
                {this.props.selectedDataById.status !== 3 ? <a style={{ position: 'absolute', right: 0, top: 0 }}
                  onClick={() => this.openAssigneeModal(associatedCommunity, managers, members)}>Change</a> : ''}
              </div> : ''}
            </Title>
          </LaneHeader> */}
          {title !== "Others" ?
            <div style={{  'width': "200px", 'margin': "3px", }} >
              <ActivityCard
                type="stage"
                activityData={this.props}
                selectedActivityData={this.props.selectedActivityData}
                activityRACIUsers={this.props.activityRACIUsers}
                selectedDataById={this.props.selectedDataById}
                selectedOrganisation={this.props.selectedOrganisation}
                // index={index}
                assignModal={this.assignModal}
                associatedTeamName={associatedTeamName}
                user={this.props.user}
                {...this.props}
              />
            </div> : null}
          <div className="activityCount" onClick={this.toggleLaneCollapsed} >
            <Icon name={this.state.collapsed ? "angle right" : "angle down"} className="vert_middle" />

            <span className="circle-dark-gray">{label}</span>
            <Popup inverted className="popupStyled" trigger={<span className="pull-right circle-blue mar_lr_1">{completedlabel}</span>} content='Completed' />
            <Popup inverted className="popupStyled" trigger={<span className="pull-right circle-red mar_lr_1">{issuelabel}</span>} content='Issue' />
          </div>
        </div>
      )
    }
  }

  renderFooter = () => {
    const { collapsibleLanes, cards } = this.props
    const { collapsed } = this.state
    if (collapsibleLanes && cards.length > 0) {
      return <LaneFooter onClick={this.toggleLaneCollapsed}>{collapsed ? <ExpandBtn /> : <CollapseBtn />}</LaneFooter>
    }
  }

  toggleLaneCollapsed = () => {

    this.setState(state => ({ collapsed: !this.state.collapsed }))
  }

  render() {
    const { loading, isDraggingOver } = this.state
    const { id, onLaneClick, ...otherProps } = this.props;
    return (
      <Section className={otherProps.isDummy ? 'no-stage-added' : null} {...otherProps} key={id} onClick={() => onLaneClick && onLaneClick(id)} draggable={false}>
        {this.renderHeader()}
        {this.renderDragContainer(isDraggingOver)}
        {loading && <Loader />}
        {this.renderFooter()}
      </Section>
    )
  }
}

Lane.propTypes = {
  actions: PropTypes.object,
  children: PropTypes.node,
  id: PropTypes.string.isRequired,
  title: PropTypes.node,
  index: PropTypes.number,
  laneSortFunction: PropTypes.func,
  style: PropTypes.object,
  cardStyle: PropTypes.object,
  tagStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  customLaneHeader: PropTypes.element,
  customCardLayout: PropTypes.bool,
  cards: PropTypes.array,
  currentPage: PropTypes.number,
  draggable: PropTypes.bool,
  collapsibleLanes: PropTypes.bool,
  droppable: PropTypes.bool,
  onLaneScroll: PropTypes.func,
  onCardClick: PropTypes.func,
  onCardDelete: PropTypes.func,
  onCardAdd: PropTypes.func,
  onLaneClick: PropTypes.func,
  newCardTemplate: PropTypes.node,
  addCardLink: PropTypes.node,
  editable: PropTypes.bool,
  cardDraggable: PropTypes.bool,
  cardDragClass: PropTypes.string
}

Lane.defaultProps = {
  style: {},
  titleStyle: {},
  labelStyle: {},
  label: undefined,
  editable: false,
  onCardAdd: () => { }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(laneActions, dispatch)
})



export default connect(null, mapDispatchToProps)(Lane)